import { CSSObject } from "styled-components";

const cssObjectForQuietState = (
	colorHex: string | undefined,
	bgColorHex: string | undefined
): CSSObject => {
	return {
		backgroundColor: bgColorHex,
		border: "none",
		".Typography": {
			color: colorHex,
		},
		".Icon svg": {
			fill: colorHex,
		},
	};
};

export default cssObjectForQuietState;
